module.exports = __webpack_public_path__ + "static/img/ureter-detail-4.c5d6b39.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/ureterpic/ureter-detail-4.jpg
// module id = HAOd
// module chunks = 52